import React from 'react';
import OrganizationInfoContainer from '@src/containers/OrganizationInfo';

const OrganizationInfo = () => <OrganizationInfoContainer />;

export default OrganizationInfo;
